import React from 'react'
import { InlineBlockTop } from './Styles.js'

export default class extends React.Component {
  render() {
    return (
      <div
        onMouseOver={() => {
          if (!this.props.readOnly) {
            return this.setState({hover: true})
          }
        }}
        onMouseLeave={() => this.setState({hover: false})}
        style={{margin: `5px`, ...this.props.style}}
      >        
        <InlineBlockTop>
          {
            this.state.hover
            ? <DefaultPrivacyList
                privacy={this.props.privacy}
                setPrivacy={p => {
                  if (!this.props.readOnly) {
                    return this.setPrivacy(p)
                  }
                }}
              />
            : <Icon
                color={this.props.privacy}
                selected={true}
              />
          }
        </InlineBlockTop>
        <InlineBlockTop>
          {
            this.props.users && this.props.users.map((user, i) => {
              return (
                <Icon
                    imageURL={user.imageURL}
                    selected={true}
                    key={i} // ideally user.id
                    // setPrivacy (remove users)
                />
              )
            })
          }
        </InlineBlockTop>
      </div>
    )    
  }

  constructor() {
    super()

    this.state = {
      hover: false,
    }
  }

  setPrivacy(p) {
    // this.setState({
    //   hover: false,
    // })
    this.props.setPrivacy(p)
  }
}

const DefaultPrivacyList = ({ privacy, setPrivacy, add }) => (
  <div>
    <InlineBlockTop>
      <Icon
          color="green"
          selected={privacy === "green" ? true : false}
          handleClick={() => {return setPrivacy && setPrivacy("green")}}
      />
      <Icon
          color="yellow"
          selected={privacy === "yellow" ? true : false}
          handleClick={() => {return setPrivacy && setPrivacy("yellow")}}
      />
      <Icon
          color="red"
          selected={privacy === "red" ? true : false}
          handleClick={() => {return setPrivacy && setPrivacy("red")}}
      />
      <Icon
          color="black"
          selected={privacy === "black" ? true : false}
          handleClick={() => {return setPrivacy && setPrivacy("black")}}
      />
    </InlineBlockTop>
    {
      // <InlineBlockTop>
      //   <Icon
      //       material="add"
      //       handleClick={() => add()}
      //       selected={true}
      //   />
      // </InlineBlockTop>
    }    
  </div>
)

class Icon extends React.Component {
  render() {
    return (
      <div
        style={{
          boxSizing: `border-box`,
          background: this.props.material === undefined && this.props.color ? this.props.color : `url("${this.props.imageURL}")`,
          backgroundSize: this.props.color ? `` : `contain`,
          height: `36px`,
          width: `36px`,
          borderRadius: `50%`,
          borderColor: `black`,
          borderStyle: `solid`,
          borderWidth: this.state.hover ? `5px` : `1px`,
          opacity: this.props.selected === true || this.state.hover ? 1 : 0.4,
        }}
        onMouseOver={() => this.setState({hover: true})}
        onMouseLeave={() => this.setState({hover: false})}
        onClick={() => {return this.props.handleClick && this.props.handleClick()}}
      >
        {
          this.props.material &&
          <span
              className="material-icons"
              style={{
                marginLeft: this.state.hover ? `-5px` : `-1px`,
                marginTop: this.state.hover ? `-5px` : `-1px`,
                fontSize:`36px`
              }}
          >
            {this.props.material}
          </span>
        }
      </div>
    )
  }

  constructor() {
    super()

    this.state = {
      hover: false,
    }
  }
}



// WEBPACK FOOTER //
// ./src/Privacy.js